var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M17.955 9.202c.253.355.38.532.38.795s-.127.441-.38.796c-1.139 1.597-4.046 5.038-7.954 5.038s-6.815-3.441-7.953-5.038c-.253-.355-.38-.533-.38-.796s.127-.44.38-.795c1.138-1.597 4.046-5.038 7.953-5.038s6.815 3.441 7.954 5.038Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M12.5 10a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
    opacity: 0.4
  })));
};
export default SvgEye;